import NewsTable from '../NewsTable';

export default function Observations() {
  return (
    <div className="obs-table-container" style={{ fontSize: '0.75rem' }}>
      <NewsTable />
    </div>
  );
}